export default "__VITE_ASSET__DY75a0q8__"